module.exports = __webpack_public_path__ + "6e562e863ccbdecfef340c407d5b75d4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/water.png
// module id = 2763
// module chunks = 0